import { useTranslation } from 'react-i18next'

import EvaluationEmpty from './EvaluationEmpty'

export default function EvaluationSection({
  className,
  career,
  talent,
  onPressCreateCareer,
  onPressCreateTalent
}) {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <h2 className='text-2xl font-semibold text-darkBlue'>
        {t('discover.evaluation_section.title')}
      </h2>
      <EvaluationEmpty
        className={'mt-4'}
        career={career}
        talent={talent}
        onPressCreateCareer={onPressCreateCareer}
        onPressCreateTalent={onPressCreateTalent}
      />
    </div>
  )
}
